import SectionHeading from "./SectionHeading";
import { directions } from "@/mocks/mayiBaoliao";

const mark = ["01", "02", "03", "04", "05"];

export default function DirectionEntry() {
  return (
    <section id="guides" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          over="Get Started · 五大方向"
          title="从哪听、去哪避，先挑一个方向"
          desc="按你的出行关注点进入对应情报线，每个方向都持续更新现场见闻与雷区提醒。"
        />

        <div className="mt-9 grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-5">
          {directions.map((d, i) => {
            const isSpot = i === 3;
            return (
              <a
                key={d.id}
                href="#live"
                className={`group flex flex-col justify-between rounded-lg border p-5 transition hover:-translate-y-1 ${
                  isSpot
                    ? "border-accent-300 bg-accent-500 text-background-50 hover:bg-accent-600"
                    : "border-background-200 bg-background-100/60 hover:border-secondary-300"
                }`}
              >
                <div>
                  <div className="flex items-start justify-between">
                    <span
                      className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                        isSpot ? "bg-background-50/20" : "bg-secondary-100"
                      }`}
                    >
                      <i
                        className={`${d.iconClass} text-xl ${
                          isSpot ? "text-background-50" : "text-secondary-700"
                        }`}
                      />
                    </span>
                    <span
                      className={`font-heading text-sm font-semibold ${
                        isSpot ? "text-background-50/80" : "text-background-400"
                      }`}
                    >
                      {mark[i]}
                    </span>
                  </div>
                  <h3
                    className={`mt-5 font-heading text-lg font-bold ${
                      isSpot ? "text-background-50" : "text-foreground-950"
                    }`}
                  >
                    {d.name}
                  </h3>
                  <p
                    className={`mt-2 text-sm leading-relaxed ${
                      isSpot ? "text-background-50/90" : "text-foreground-600"
                    }`}
                  >
                    {d.desc}
                  </p>
                </div>
                <div className="mt-6 flex items-center justify-between">
                  <span
                    className={`text-xs ${isSpot ? "text-background-50/80" : "text-foreground-400"}`}
                  >
                    持续更新中
                  </span>
                  <span
                    className={`flex items-center gap-1 whitespace-nowrap text-sm font-semibold transition ${
                      isSpot ? "text-background-50" : "text-primary-700 group-hover:text-primary-900"
                    }`}
                  >
                    去避坑
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}